import { defineComponent as _defineComponent } from 'vue'
import TableActionsList from '@/components/tableWithActions/TableActionsList.vue';
import { useI18n } from '@/composables/i18n';
import { SortOrder } from '@/models/enums/SortOrder';
import { isNil } from '@/utils/misc';
import { computed, useSlots } from 'vue';

type PaginationPosition = 'top' | 'bottom';
type SortIconSize = 'is-small' | 'is-medium' | 'is-large' | '';


/**
 * @deprecated: To be replaced by TableWithActions2 in the (near, I hope) future.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TableWithActions',
  props: {
    data: null,
    paginated: { type: Boolean, default: true },
    rowsPerPage: { default: 10 },
    paginationSimple: { type: Boolean, default: false },
    paginationPosition: { default: 'bottom' },
    defaultSortDirection: { default: SortOrder.Ascending },
    sortIcon: { default: 'arrow-up' },
    sortIconSize: { default: 'is-small' },
    defaultSort: null,
    titleField: null,
    titleLabel: null,
    loading: { type: Boolean, default: false },
    hoverable: { type: Boolean, default: false },
    detailed: { type: Boolean, default: false },
    detailKey: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {





const $slots = useSlots();
const { t } = useI18n();

const actionsWereDeclared = computed<boolean>(() => !isNil($slots.actions));

const defaultTitleLabel = computed<string>(() => t('form.name').toString());

const hasBottomLeftSlot = computed<boolean>(() => 'bottom-left' in $slots);

const hasDetailsSlot = computed<boolean>(() => 'detail' in $slots);

return { __sfc: true,emit, $slots, t, actionsWereDeclared, defaultTitleLabel, hasBottomLeftSlot, hasDetailsSlot, TableActionsList }
}

})